import { render, staticRenderFns } from "./TableListPage.vue?vue&type=template&id=3987eb12&scoped=true"
import script from "./TableListPage.vue?vue&type=script&lang=js"
export * from "./TableListPage.vue?vue&type=script&lang=js"
import style0 from "./TableListPage.vue?vue&type=style&index=0&id=3987eb12&prod&lang=scss&scoped=true"
import style1 from "./TableListPage.vue?vue&type=style&index=1&id=3987eb12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987eb12",
  null
  
)

export default component.exports